const map = {
	"./board/corner-bottom-left.png": 1064,
	"./board/corner-bottom-right.png": 6993,
	"./board/corner-top-left.png": 976,
	"./board/corner-top-right.png": 953,
	"./board/hole.png": 8527,
	"./board/plank-bottom.png": 2209,
	"./board/plank-left.png": 3440,
	"./board/plank-right.png": 4164,
	"./board/plank-top.png": 515,
	"./buttons/button-large-border.png": 9255,
	"./buttons/button-medium-border.png": 3723,
	"./buttons/button-nav-border.png": 8205,
	"./flag/flag-normal.png": 1611,
	"./flag/flag-ripped.png": 7134,
	"./gems/border-default.png": 6865,
	"./gems/broken-shadow.png": 3783,
	"./gems/gem-apple.png": 3245,
	"./gems/gem-blue.png": 7697,
	"./gems/gem-bone.png": 7247,
	"./gems/gem-brick.png": 7974,
	"./gems/gem-bronze.png": 4773,
	"./gems/gem-caviar.png": 5295,
	"./gems/gem-cheese.png": 6318,
	"./gems/gem-coral.png": 7526,
	"./gems/gem-foam.png": 6486,
	"./gems/gem-football.png": 698,
	"./gems/gem-geode.png": 595,
	"./gems/gem-gold-stone.png": 8047,
	"./gems/gem-gold.png": 3895,
	"./gems/gem-golf.png": 4797,
	"./gems/gem-grass.png": 7043,
	"./gems/gem-green.png": 5096,
	"./gems/gem-honey.png": 9980,
	"./gems/gem-ice.png": 8980,
	"./gems/gem-lava.png": 7183,
	"./gems/gem-marble.png": 5938,
	"./gems/gem-neutral.png": 7004,
	"./gems/gem-onion.png": 8522,
	"./gems/gem-orange.png": 6579,
	"./gems/gem-paua.png": 6234,
	"./gems/gem-pearl.png": 4641,
	"./gems/gem-pinecone.png": 7326,
	"./gems/gem-pumpkin.png": 9141,
	"./gems/gem-purple.png": 6243,
	"./gems/gem-red.png": 6212,
	"./gems/gem-scarab.png": 6443,
	"./gems/gem-silver-stone.png": 7042,
	"./gems/gem-silver.png": 5266,
	"./gems/gem-slime.png": 8725,
	"./gems/gem-star.png": 2573,
	"./gems/gem-sushi.png": 5747,
	"./gems/gem-tennis.png": 7460,
	"./gems/gem-void.png": 9219,
	"./gems/gem-vortex.png": 8433,
	"./gems/gem-wood.png": 8862,
	"./gems/gem-yarn.png": 9887,
	"./gems/gem-yellow.png": 6277,
	"./icons/sparks.png": 6825,
	"./logo.png": 6659,
	"./logo/logo-full.png": 8475,
	"./panel/panel-border-bottom.png": 1504,
	"./panel/panel-border-left.png": 7898,
	"./panel/panel-border-right.png": 2339,
	"./panel/panel-border-top.png": 5080,
	"./panel/store-tablet-landscape.png": 619,
	"./round-button/round-button-bg-pressed.png": 9864,
	"./round-button/round-button-bg.png": 25
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7595;